export default {
  'editorial-staff': 'Unser Redaktionsteam',
  'published-on': 'Veröffentlicht am',
  'read-articles': 'Artikel dieses Autors lesen',
  'about-author': 'Über den Autor',
}
